import gql from 'graphql-tag'

export default gql`
    query AvailableStreets($zipcode: String!, $city: String!, $district: String) {
        availableStreets(zipcode: $zipcode, city: $city, district: $district)
    }
`
